import BannerNotification from './BannerNotification'

export default BannerNotification
